import { useRef } from "react";
import { Flex, Icon, Input } from "@chakra-ui/react";
import { RiSearchLine } from 'react-icons/ri';

interface SearchBoxParams {
	handleSearchProduct?: (search: string) => void;
}

const SearchBox: React.FC<SearchBoxParams> = ({ handleSearchProduct }) => {
	const searchInputRef = useRef<HTMLInputElement>(null);

	return (
		<Flex
			as="label"
			flex="1"
			py={["1", "2"]}
			pl="2"
			pr="4"
			mr="2"
			// mx={["4", "10"]}
			// maxWidth={400}
			alignSelf="center"
			color="gray.900"
			position="relative"
			bg="white"
			borderRadius="full"
		>
			<Input
				fontSize="16"
				color="gray.900"
				variant="unstyled"
				px="4"
				mr="4"
				placeholder="Pesquisar"
				_placeholder={{ color: 'gray.400' }}
				ref={searchInputRef}
				onChange={e => handleSearchProduct && handleSearchProduct(e.target.value)}
			/>

			<Icon as={RiSearchLine} fontSize={["18", "20"]} color="gray.400" />
		</Flex>
	)
}

export default SearchBox;